<div class="input-wrapper" [style.display]="visible ? '' : 'none'">
  <!-- Label -->
  <label *ngIf="fieldSchema?.label" class="input-label">
    {{ fieldSchema.label }}
  </label>

  <!-- Input Field -->
  <div class="input-container">
    <input
      #inputElement
      class="custom-input"
      [type]="fieldSchema?.inputType || 'text'"
      [placeholder]="fieldSchema?.placeholder || ''"
      [value]="value"
      [disabled]="disabled"
      [readonly]="fieldSchema?.readonly || false"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
      (focus)="onFocus()"
      [class.has-error]="shouldShowErrors()"
      [class.has-content]="hasContent()"
    />
  </div>

  <!-- Help Text / Format Hint -->
  <small *ngIf="shouldShowHelpText()" class="help-text">
    {{ getHelpTextOrFormatHint() }}
  </small>

  <!-- Error Messages - Show during typing for email validation -->
  <div *ngIf="shouldShowErrors()" class="error-messages">
    <small *ngFor="let error of getErrorMessages()" class="error-message">
      {{ error }}
    </small>
  </div>
</div>
